<template>
  <a-layout-content
    v-if="$route.meta.hasLayout == false"
    :style="
      $route.name !== 'Open View' &&
      $route.name !== 'Open Proposal' &&
      $route.name !== 'Open Shipping' &&
      $route.name !== 'Open Installation' &&
      $route.name !== 'Open Porting' &&
      $route.name !== 'Login'
        ? { padding: '24px 16px', minHeight: '850px' }
        : ''
    "
  >
    <router-view :key="$route.name" />
  </a-layout-content>
  <Layout v-if="$route.meta.hasLayout == true">
    <a-layout-content
      :class="
        $route.name == 'Edit Ticket' || $route.name == 'Chat Porting'
          ? 'page-content-section1'
          : 'page-content-section'
      "
    >
      <router-view :key="$route.name" />
    </a-layout-content>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout/Layout.vue";
export default {
  name: "App",
  components: { Layout },
  mounted() {
    let newTime = new Date().getTime();
    if (localStorage.LoginTime) {
      let oldTime = localStorage.getItem("LoginTime");
      if (newTime - oldTime > 43200000) {
        localStorage.clear();
        this.$router.go();
      }
    }
  },
};
</script>
